import { Capacitor } from '@capacitor/core'
import { useChromecastWeb } from './useChromecastWeb'
import { ChromecastProps } from './interfaces/ChromecastProps'
import { useChromecastNative } from './useChromecastNative'

export const useChromecast = (props: ChromecastProps) => {
  return Capacitor.getPlatform() === 'web'
    ? useChromecastWeb(props)
    : useChromecastNative(props)
}
